import React from "react";
import "./login.scss";
import Input from "../../components/Tag/input/Input";
import logo from "../../assets/image/logo-amospa.svg";
import { useState } from "react";
import axios from "axios";
import ModalUmum from "../../modal/modalUmum/ModalUmum";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const userLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await axios.post("https://mobile.amospa.com/staff/login", {
        email,
        password,
      });
      console.log(result);
      if (result.data.msg == "login Success") {
        window.sessionStorage.setItem("dataLogin", result.data.token);
        window.location.href = "/homepage/";
      } else {
        setModalShow(true);
      }
    } catch (error) {
      console.log(error);
      setModalShow(true);
    }
  };

  const handleNext = async () => {
    setModalShow(false);
  };

  return (
    <div className="login">
      <div className="container">
        <div className="row">
          <div className="col-md-12 login-image">
            <img src={logo} alt="imageLogin" />
          </div>
        </div>

        {/* Form Login */}
        <div className="col-md-12">
          <div className="form-login">
            <div className="content">
              <h3 className="welcome">WELCOME</h3>
              <hr className="hr" />
              <form onSubmit={userLogin}>
                <label>Email</label>
                <div className="input-login">
                  <span className="icon">
                    <img
                      src="https://img.icons8.com/ios-glyphs/30/undefined/user--v1.png"
                      alt="logoUsername"
                    />
                  </span>
                  <div className="container-input">
                    <Input
                      name="email"
                      type="text"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <label className="mt-3">Password</label>
                <div className="input-login">
                  <span className="icon">
                    <img
                      src="https://img.icons8.com/external-smashingstocks-glyph-smashing-stocks/66/undefined/external-padlock-mailing-smashingstocks-glyph-smashing-stocks.png"
                      alt="logoPassword"
                    />
                  </span>
                  <div className="container-input">
                    <Input
                      name="password"
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="button-login">
                  <button>Login</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        title="Login failed, recheck email and password"
        onHide={() => setModalShow(false)}
        nextButton={handleNext}
      />
    </div>
  );
}

export default Login;
